import { EUserTrustLevel, IUser } from '../types/user/user';

export const defaultUser: IUser = {
  isNew: true,
  agentAccountType: 'agency',
  phones: [
    {
      phone: '79991112233',
      confirmed: true,
    },
    {
      phone: '79159999999',
      confirmed: true,
    },
    {
      phone: '79992222222',
      confirmed: true,
    },
    {
      phone: '79999995555',
      confirmed: true,
    },
    {
      phone: '79639999999',
      confirmed: true,
    },
    {
      phone: '79269999999',
      confirmed: true,
    },
    {
      phone: '79999839523',
      confirmed: true,
    },
    {
      phone: '79815556677',
      confirmed: true,
    },
    {
      phone: '79999999999',
      confirmed: true,
    },
    {
      phone: '79998887776',
      confirmed: true,
    },
    {
      phone: '79988887788',
      confirmed: true,
    },
    {
      phone: '79989988999',
      confirmed: true,
    },
    {
      phone: '79981234567',
      confirmed: true,
    },
  ],
  isBuilder: false,
  criteoEmail: 'afdf7a622ba3f9874a8dcf9b17070fd4',
  isProfi: true,
  isAgent: true,
  publicProfile: null,
  id: 500271,
  userTrustLevel: EUserTrustLevel.Involved,
  avatarUrl: 'http://www.master.dev3.cian.ru/avatar.axd?i=6676795&t=1&p=2',
  kpnWebimChecksum: '5b7eb278119c07df8b5e2dd73ab7a643133c5b2d9b5fd5b1144f3d2efc65a556',
  canPublishOffer: null,
  email: 'dasd+555@c.ru',
  userId: 6676795,
  isModerator: true,
  isSubscriptions: true,
  accountType: 'natural',
  tariff: ['profi'],
  permissions: {
    canViewHiddenAnnouncements: true,
    canViewUsers: true,
    canModerateUsers: true,
    canViewAnnouncements: true,
    canModerateAnnouncements: true,
    canHandleAnnouncements: false,
    canViewListingSort: true,
    canModerateAnnouncementsExpert: true,
    canUseModerationComplaints: false,
    canUseHiddenBase: true,
  },
  displayName: 'ID:500271',
  userType: 'realtor_prof',
  isCianPartner: false,
  balance: 38481.07,
  isAuthenticated: true,
};
